export function findFileExtension(fileName) {

    let indexOfPeriod = fileName.lastIndexOf('.');

    if (indexOfPeriod == -1) {
        return '';
    }

    return fileName.substring(indexOfPeriod);
}